import React from 'react';
import './SadenDashboardItem.scss';

const Title = ({title}) => {
    return (
        <div className='title-card'>

            <p>{title}</p>

            <div className='green-box'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M9.56055 18.75C9.15055 18.75 8.81055 18.41 8.81055 18V13C8.81055 12.59 9.15055 12.25 9.56055 12.25C9.97055 12.25 10.3105 12.59 10.3105 13V18C10.3105 18.41 9.97055 18.75 9.56055 18.75Z"
                        fill="white"/>
                    <path
                        d="M12 16.25H7C6.59 16.25 6.25 15.91 6.25 15.5C6.25 15.09 6.59 14.75 7 14.75H12C12.41 14.75 12.75 15.09 12.75 15.5C12.75 15.91 12.41 16.25 12 16.25Z"
                        fill="white"/>
                    <path
                        d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
                        fill="white"/>
                    <path
                        d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
                        fill="white"/>
                    <path
                        d="M8.85002 22.8102C6.38002 22.8102 4.75002 22.2702 3.73002 21.1102C2.55002 19.7802 2.36 17.7902 2.32 16.0202L2.19002 9.85018C2.09002 5.12018 3.66001 3.15018 7.76001 2.84018L15.8 2.68018C15.82 2.68018 15.83 2.68018 15.84 2.68018C19.95 2.82018 21.59 4.72018 21.69 9.46018L21.81 15.6302C21.85 17.4002 21.73 19.4002 20.61 20.7702C19.59 22.0202 17.87 22.6302 15.2 22.6902L9.20001 22.8102C9.08001 22.8102 8.96002 22.8102 8.85002 22.8102ZM15.8 4.17018L7.83 4.33018C5.03 4.55018 3.60002 5.45018 3.69002 9.82018L3.82 15.9902C3.86 18.1102 4.17 19.3502 4.85 20.1202C5.61 20.9802 6.98001 21.3602 9.18002 21.3102L15.18 21.1902C17.37 21.1502 18.73 20.7102 19.46 19.8202C20.11 19.0302 20.37 17.7802 20.32 15.6602L20.2 9.49018C20.1 5.13018 18.64 4.27018 15.8 4.17018Z"
                        fill="white"/>
                </svg>
            </div>
        </div>
    );
};

export default Title;
